import CalendarScheduleSlotModel from "../../../models/CalendarScheduleSlotModel";
import CompactDoneSlot from "./CompactDoneSlot";
import ExtendedDoneSlot from "./ExtendedDoneSlot";
import { useState } from "react";
import WeeklySessionInfo from "../../sessions/WeeklySessionInfo";

export default function DoneSlot(props: {
  slot: CalendarScheduleSlotModel;
  compact: boolean;
  onClick: (slot: CalendarScheduleSlotModel) => void;
}) {
  const [open, setOpen] = useState<boolean>(false);

  if (props.compact) {
    return (
      <>
        <CompactDoneSlot setOpen={() => setOpen(true)} {...props} />
        {!!props?.slot && (
          <>
            <WeeklySessionInfo
              session={props?.slot}
              onClose={() => setOpen(false)}
              cancel={false}
              open={open}
              setIsOpen={() => {
                setOpen(false);
              }}
            />
          </>
        )}
      </>
    );
  }

  return <ExtendedDoneSlot {...props} />;
}
